import { render } from "./CharacterCount.vue?vue&type=template&id=0774ae96"
import script from "./CharacterCount.vue?vue&type=script&lang=js"
export * from "./CharacterCount.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__